import { localized } from "@msuite/ui/localization";
import {
	createColumnHelper,
	createMeta,
	createRowActions,
	createSubRowHandle,
} from "@msuite/ui/table";
import { OrderStateTag } from "@msuite/ui/tag";
import { createdAtFormatter } from "@msuite/utils/date";
import {
	getDeliveryWindowString,
	getOrderNumberString,
	getOrderStateTranslationKey,
} from "@msuite/utils/stock";
import { guardString } from "@msuite/utils/strings";
import type { OrderListItem } from "@msuite/utils/types";
import { RowActions } from "./row-actions";
import { Link } from "@msuite/ui/link";

const columnHelper = createColumnHelper<OrderListItem>();

export const columns = [
	createSubRowHandle<OrderListItem>(),
	columnHelper.accessor((row) => getOrderNumberString(row.number), {
		id: "number",
		header: localized("general.number"),
		cell: (cell) => cell.getValue(),
		meta: createMeta({
			isTabular: true,
		}),
	}),
	columnHelper.accessor("deliveryDate", {
		id: "delivery-window",
		header: localized("stock.delivery_window"),
		// The accessor stays the raw delivery date, so sorting and search run on the date rather
		// than on the formatted string, whose weekday prefix would sort alphabetically.
		cell: (cell) => getDeliveryWindowString(cell.getValue(), cell.row.original.tourWave),
		size: 240,
	}),
	columnHelper.accessor(createdAtFormatter, {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("userName", {
		id: "userName",
		header: localized("general_fields.created_by"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("projectName", {
		id: "projectName",
		header: localized("projects.project"),
		cell: (cell) => (
			<Link href={`/projects/${cell.row.original.projectId}`}>{cell.getValue()}</Link>
		),
	}),
	columnHelper.accessor("tourWave.name", {
		id: "tourWaveName",
		header: localized("stock.tour_wave"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor((row) => localized(getOrderStateTranslationKey(row.state)), {
		id: "state",
		header: localized("general.state"),
		cell: (cell) => <OrderStateTag state={cell.row.original.state} />,
	}),
	createRowActions(RowActions),
];
